// Geometry primitive models
export { default as Cone } from './cone';
export { default as Cube } from './cube';
export { default as Cylinder } from './cylinder';
export { default as IcoSphere } from './ico-sphere';
export { default as Plane } from './plane';
export { default as Sphere } from './sphere';
export { default as TruncatedCone } from './truncated-cone'; // GPGPU models

export { default as ClipSpace } from './clip-space';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/luma.gl/dist/esm/models/index.js
// module id = 323
// module chunks = 0